module.exports = __webpack_public_path__ + "assets/images/avatar-recipient.jpg?30e77732ca835f25b4fdd3c9759e97a7";


//////////////////
// WEBPACK FOOTER
// ./_source/images/avatar-recipient.jpg
// module id = 166
// module chunks = 0